import { WizDatasource } from './../../../../services/collections/wiz-datasource';

/**
 * Identifiant de la donnée dans le dataTransfer de la donnée
 */
export const DND_DATA_ID: string = 'grid_dnd/data-id';

/**
 * Action à effectuer sur le drop :
 * copy: on copie l'élément, il sera donc présent dans les deux sources
 * move: on déplace l'élément, il sera donc supprimé dans la datasource d'origine
 */
export type GridDropAction = 'copy' | 'move' | 'reorder';

/**
 * Définition des données transmises dans l'event de drag and drop
 */
export type GridDNDData<T> = {
  /**
   * Le configuration du grid qui a émit l'event de dnd
   */
  sourceConfig: GridDNDConfig<T>,
  /**
   * La source de donnée du grid qui a emit le drag and drop
   */
  source: WizDatasource<T>,
  /**
   * Les données à drag & droppée
   */
  data: T,
  /**
   * Composant source qui est à l'origine de l'event
   */
  sourceComponent: any
}

/**
 * Configuration du drag and drop pour le grid
 */
export type GridDNDConfig<T> = {
  /**
   * Drag autorisé depuis le grid
   */
  dragEnabled: boolean,
  /**
   * Drop autorisé depuis le grid
   */
  dropEnabled: boolean,
  /**
   * Fonction appelée sur le drag over permettant d'autoriser ou non le drop
   *
   *  Optionnel, si pas de fonction, on accepte tout
   */
  dropAccept?: (data: T) => boolean,
  /**
   * Fonction appelée sur le drag start permettant d'autoriser ou non le drag sur l'item
   *
   * Optionnel, si pas de fonction, on accepte tout
   */
  itemDraggable?: (data: T) => boolean,
  /**
   * Action à effectuer sur le drop :
   * copy: on copie l'élément, il sera donc présent dans les deux sources
   * move: on déplace l'élément, il sera donc supprimé dans la datasource d'origine
   */
  dropAction: GridDropAction
}
